import React from "react";
import type {FunctionComponent} from "react";
import {useWhenUserLogic} from "./WhenUser.logic";

export interface IWhenUserProps {
  isMember?: boolean;
  membershipGiveSongAccess?: boolean;
}

export const WhenUser: FunctionComponent<IWhenUserProps> = ({isMember, membershipGiveSongAccess, children}) => {
  const {isAllowed} = useWhenUserLogic({isMember, membershipGiveSongAccess});

  if (!isAllowed){
    // not allowed to be rendered
    return null;
  }

  return <>{children}</>;
}

